export default "__VITE_ASSET__DLzhzLDW__"